// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { InputHTMLAttributes } from 'react';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import MomentLocaleUtils from 'react-day-picker/moment';
import { BiCalendar } from 'react-icons/bi';
import InputMask from 'react-input-mask';

import { Input } from '~/components';

import 'react-day-picker/lib/style.css';

import 'moment/locale/pt-br';

interface DatePickerProps extends InputHTMLAttributes<HTMLInputElement> {
  fieldLabel: string;
  name: string;
  onChange?: (date: Date | undefined) => void;
  value?: Date;
}

function DatePicker({
  name,
  fieldLabel,
  onChange,
  value,
}: DatePickerProps): JSX.Element {
  return (
    <DayPickerInput
      format="DD/MM/yyyy"
      value={value}
      onDayChange={onChange}
      dayPickerProps={{
        localeUtils: MomentLocaleUtils,
        locale: 'pt-br',
        disabledDays: { after: new Date(Date.now()) },
      }}
      formatDate={MomentLocaleUtils.formatDate}
      parseDate={MomentLocaleUtils.parseDate}
      placeholder="DD/MM/YYYY"
      component={(props: DatePickerProps) => (
        <InputMask {...props} mask="99/99/9999">
          {(inputProps: any) => (
            <Input
              label={fieldLabel}
              name={name}
              icon={BiCalendar}
              iconPosition="left"
              {...inputProps}
            />
          )}
        </InputMask>
      )}
    />
  );
}

DatePicker.defaultProps = {
  onChange: () => {
    return undefined;
  },
  value: undefined,
};

export default DatePicker;
